// extracted by css-extract-rspack-plugin
export default {"IconButton":"SearchButton-module__IconButton__SBlqu"};